import styled, { css } from 'styled-components'

import type { ProductsListProps } from './types'

export const Container = styled.table<Pick<ProductsListProps, 'size'>>`
  width: 100%;
  border-collapse: collapse;
  margin: -4px 0;

  ${({ size }) =>
    size === 'small' &&
    css`
      margin: -4px 0;
    `};
`
